import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Chip, Divider, IconButton, Paper, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectTitle } from '../../redux/reducers/catalogsReducer';
import { saveFinding } from '../../redux/reducers/findingsReducer';

function AssessmentFinding({ finding, review = false }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const controlTitle = useSelector((state) => selectTitle(state, finding.controlId));
  const [expanded, setExpanded] = useState(false);
  const [response, setResponse] = useState(finding.response);
  const [unsavedChanges, setUnsavedChanges] = useState(false);

  const handleChange = (event) => {
    const { value } = event.target;
    setResponse(value);
    setUnsavedChanges(true);
  };

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  const handleSave = () => {
    if (unsavedChanges) {
      dispatch(saveFinding({ ...finding, response }));
    }
  };

  return (
    <Paper elevation={4} variant="elevation" subtype="finding">
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack>
          <Typography id={finding.title} variant="body1">{finding.title}</Typography>
          <Typography variant="body2">{controlTitle}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Chip
            variant="filled"
            size="medium"
            subtype={finding.criticality}
            label={<Typography variant="chip">{t(`finding.criticality.${finding.criticality}`)}</Typography>}
          />
          <IconButton id={`expand-${finding.title}`} onClick={() => toggleExpand()}>{expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</IconButton>
        </Stack>
      </Stack>
      {expanded && (
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Divider />
          <Stack direction="row" spacing={2}>
            <Box sx={{ flex: 1 }}>
              <Stack spacing={2}>
                <Stack spacing={1}>
                  <Stack>
                    <Typography>{t('assessment.review.findings.description')}</Typography>
                    <Typography variant="body2">{finding.description}</Typography>
                  </Stack>
                  <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                    {finding.usualFindings.map((usualFinding) => (
                      <Chip
                        key={usualFinding}
                        color="primary"
                        size="small"
                        label={t(`finding.usualFinding.${usualFinding}`)}
                      />
                    ))}
                  </Stack>
                </Stack>
                <Stack>
                  <Typography>{t('assessment.review.findings.recommendation')}</Typography>
                  <Typography variant="body2">{finding.recommendation}</Typography>
                </Stack>
              </Stack>
            </Box>
            <Box sx={{ flex: 1 }}>
              {review ? (
                <TextField
                  name="response"
                  id={`${controlTitle} ${finding.title}-response`}
                  defaultValue={finding.response}
                  onChange={handleChange}
                  onBlur={() => handleSave()}
                  multiline
                  minRows="4"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label={t('assessment.review.findings.response')}
                  sx={{ backgroundColor: 'white' }}
                />
              ) : (
                <Stack>
                  <Typography>{t('assessment.review.findings.response')}</Typography>
                  <Typography variant="body2">{finding.response}</Typography>
                </Stack>
              )}
            </Box>
          </Stack>
        </Stack>
      )}
    </Paper>
  );
}

export default AssessmentFinding;
